const getCalendarEventById = (apiGet) => (roomId, id) => apiGet(`/users/${roomId}/events/${id}`);

export default getCalendarEventById;
